<div id="view-managerwise-advisors-dialog">
    <!-- Sprinner -->
    @if(this.setSprinner()) {
    <div class="pias-spinner">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    }

    <div id="dialog-title" mat-dialog-title>
        <span id="dialog-header">Incepted APE - By Advisors [{{this.managerRepCode}} : {{this.managerName}}]</span>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div class="position-relative" style="max-width: 500px">
            <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                style="background: #f0f0f0; color: #1c3a7a" [formControl]="inceptedApeBranchAdvisorTableFilterFc"
                (keyup)="__applyInceptedApeBranchAdvisorsDataFilter()" placeholder="Search advisors..." #input />

            <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y" style="color: #888888"></i>

            <button *ngIf="inceptedApeBranchAdvisorTableFilterFc.value"
                class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                (click)="clearSearchField()">
                <i class="fas fa-times" style="color: #888888"></i>
            </button>
        </div>
        <mat-divider class="pias-divider"></mat-divider>
        <div id="view-managerwise-advisors-table">
            <table mat-table [dataSource]="this.inceptedApeByAdvisorTableDataSource" matSort matSortDisableClear
                matSortActive="yearTotal" matSortDirection="desc" #inceptedApeByAdvisorTableSort="matSort"
                class="pias-table table table-hover table-bordered bg-light border border-2">

                <!-- Rep Code Column — carries the chevron that expands the carrier chips -->
                <ng-container matColumnDef="repCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> Rep.
                        Code </th>
                    <td mat-cell *matCellDef="let apeData" class="text-start" style="max-width: 130px;">
                        <button type="button" class="ape-expand-btn" [class.open]="isRowExpanded(apeData.repCode)"
                            [attr.aria-expanded]="isRowExpanded(apeData.repCode)"
                            [attr.aria-label]="'Show carrier breakdown for ' + apeData.repCode"
                            (click)="toggleRow(apeData.repCode)">
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                        {{apeData.repCode}}
                    </td>
                </ng-container>

                <!-- Person Name Column -->
                <ng-container matColumnDef="personName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> Name
                    </th>
                    <td mat-cell *matCellDef="let apeData" class="text-start" style="max-width: 150px;">
                        {{apeData.personName}} </td>
                </ng-container>

                <!-- MTD — total across every carrier, expanding into per-carrier chips -->
                <ng-container matColumnDef="mtdByCarrier">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="monthTotal" class="align-middle fw-bold">
                        Month to Date </th>
                    <td mat-cell *matCellDef="let apeData" class="ape-carrier-cell">
                        <div class="ape-cell-head">
                            <span class="ape-cell-total">{{ apeData.monthTotal | currency: 'SGD' : 'symbol-narrow' :
                                '1.0-0' }}</span>
                            <span class="ape-cell-cases">{{ apeData.monthTotalCase }} cases</span>
                        </div>
                        @if (isRowExpanded(apeData.repCode)) {
                        <div class="ape-cell-breakdown">
                            <div class="ape-mix">
                                @for (carrier of carriersOf(apeData); track carrier.name) {
                                @if(carrier.mtdApe > 0 && carrier.mtdCase > 0){    
                                <span class="ape-mix-seg" [style.width]="carrier.mtdShare"
                                    [style.background]="carrier.color"></span>
                                }
                                }
                            </div>
                            <div class="ape-chips">
                                @for (carrier of carriersOf(apeData); track carrier.name) {
                                @if(carrier.mtdApe > 0 && carrier.mtdCase > 0){    
                                <span class="ape-chip">
                                    <span class="ape-chip-dot" [style.background]="carrier.color">{{ carrier.initial
                                        }}</span>
                                    <span class="ape-chip-name" [title]="carrier.name">{{ carrier.name }}</span>
                                    <span class="ape-chip-ape">{{ carrier.mtdApe | currency: 'SGD' : 'symbol-narrow' :
                                        '1.0-0' }}</span>
                                    <span class="ape-chip-cases">{{ carrier.mtdCase }}
                                        {{ carrier.mtdCase === 1 ? 'case' : 'cases' }}</span>
                                </span>
                                }
                                }
                            </div>
                        </div>
                        }
                    </td>
                </ng-container>

                <!-- YTD — same cell, year to date -->
                <ng-container matColumnDef="ytdByCarrier">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="yearTotal" class="align-middle fw-bold"> Year
                        to Date </th>
                    <td mat-cell *matCellDef="let apeData" class="ape-carrier-cell ytd">
                        <div class="ape-cell-head">
                            <span class="ape-cell-total">{{ apeData.yearTotal | currency: 'SGD' : 'symbol-narrow' :
                                '1.0-0' }}</span>
                            <span class="ape-cell-cases">{{ apeData.yearTotalCase }} cases</span>
                        </div>
                        @if (isRowExpanded(apeData.repCode)) {
                        <div class="ape-cell-breakdown">
                            <div class="ape-mix">
                                @for (carrier of carriersOf(apeData); track carrier.name) {
                                @if(carrier.ytdApe > 0 && carrier.ytdCase > 0){     
                                <span class="ape-mix-seg" [style.width]="carrier.ytdShare"
                                    [style.background]="carrier.color"></span>
                                }    
                                }
                            </div>
                            <div class="ape-chips">
                                @for (carrier of carriersOf(apeData); track carrier.name) {
                                @if(carrier.ytdApe > 0 && carrier.ytdCase > 0){    
                                <span class="ape-chip">
                                    <span class="ape-chip-dot" [style.background]="carrier.color">{{ carrier.initial
                                        }}</span>
                                    <span class="ape-chip-name" [title]="carrier.name">{{ carrier.name }}</span>
                                    <span class="ape-chip-ape">{{ carrier.ytdApe | currency: 'SGD' : 'symbol-narrow' :
                                        '1.0-0' }}</span>
                                    <span class="ape-chip-cases">{{ carrier.ytdCase }}
                                        {{ carrier.ytdCase === 1 ? 'case' : 'cases' }}</span>
                                </span>
                                }
                                }
                            </div>
                        </div>
                        }
                    </td>
                </ng-container>

                <!-- Year Total Column — hidden for now; the YTD cell already carries the
                     same figure. Also commented out of the display column list in the .ts.
                <ng-container matColumnDef="yearTotal">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="text-center align-middle fw-bold"> Year Total </th>
                    <td mat-cell *matCellDef="let apeData" class="text-end ape-year-total"> {{ apeData.yearTotal |
                        currency: 'SGD' :
                        'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>
                -->

                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="inceptedApeByAdvisorTableDisplayDataRow; sticky: true">
                </tr>

                <!-- Data Row -->
                <tr mat-row *matRowDef="let row; columns: inceptedApeByAdvisorTableDisplayDataRow;"
                    [class.ape-row-open]="isRowExpanded(row.repCode)"></tr>
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data found.</td>
                </tr>
            </table>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
        <!-- Incepted APE Data Table Paginator -->
        <mat-paginator #inceptedApeByAdvisorTablePaginator [pageSizeOptions]="[10,20,50]" showFirstLastButtons
            aria-label="Select page of incepted APE data"></mat-paginator>
    </mat-dialog-actions>
</div>
